import React from 'react';
import {Select} from "antd";
import {QueryKey} from "@tanstack/react-query";
import {useCommonUseQuery} from "../../../../../Common/hooks/rest/ReacQueryHook";
import {DeptData} from "../../index/DocumentMgr/data/UserData";
import {procAdminService} from "../../../../../Common/util/ProcService";

interface Option {
    value: string | number;
    label: string;
    children?: Option[];
}

export interface SelectDeptProps{
    onChangeValue:(value:string)=>void,
}



function SelectDept(props:SelectDeptProps)
{
    const {onChangeValue} = props;
    const serviceCode:string       =   process.env.REACT_APP_SERVICE_NAME as string;
    const queryKey:QueryKey =   [`DeptData`];
    const { data} = useCommonUseQuery<DeptData[]>(
        queryKey,
        () =>procAdminService<DeptData[]>("post", `${serviceCode}ADS12`, null));

    const onChange = (value: string[]) => {
        console.log(value);
    };

    function getOption(input:DeptData[]):{ label: string | null; value: string | null }[]
    {
        let options: { label: string | null; value: string | null }[] = [{
            value:"ALL", label:"전체"
        }]
        return options.concat( input.map(deptData => ({value: deptData.deptCD, label: deptData.deptName})) );
    }

    const options: { label: string | null; value: string | null }[] = data ? getOption(data) : [{
            value: 'Loading',
            label: 'Loading...',
        },
    ];

    return (
        <Select
            style={{width:"180px", marginRight:"10px"}}
            onChange={(value, selectedOptions) => {
                const selectedValue = Array.isArray(value) ? value.join(', ') : value;
                onChangeValue(selectedValue); // 문자열 또는 문자열 배열
            }}
            options={options}
            placeholder={"부서정보"}
        />
    );

};

export default SelectDept;
